import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'

import { Button } from '@/components/ui/button'
import { ConfirmationDialog } from '@/components/ui/confirmation-dialog'
import { parseError } from '@/lib/errors'
import { type SequenceTemplate, useDeleteSequenceTemplate } from '@/models/sequenceTemplate'

interface DeleteSequenceTemplateButtonProps {
  template: SequenceTemplate
}

export function DeleteSequenceTemplateButton({ template }: DeleteSequenceTemplateButtonProps) {
  const deleteMutation = useDeleteSequenceTemplate()

  async function handleDelete() {
    try {
      await deleteMutation.mutateAsync(template.id)
    } catch (err) {
      toast.error(parseError(err))
    }
  }

  return (
    <ConfirmationDialog
      title={template.isGlobal ? 'Delete this global template?' : 'Delete this template?'}
      description={
        template.isGlobal
          ? 'Everyone on the team loses it. Sequences already started from it keep their steps.'
          : 'Sequences already started from it keep their steps.'
      }
      confirmLabel="Delete"
      onConfirm={handleDelete}
    >
      <Button variant="destructive" disabled={deleteMutation.isPending}>
        <Trash2 />
        Delete
      </Button>
    </ConfirmationDialog>
  )
}
